import React from 'react';
import { makeStyles } from '@mui/styles';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { useDropzone } from 'react-dropzone';

import { Notifier } from '@components';
import { Divider } from '@mui/material';

const useStyles = makeStyles((theme) => ({
  typography: {
    padding: theme.spacing(2),
  },
}));

export default function SimplePopover(props) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [url, setUrl] = React.useState('');

  const onDrop = React.useCallback((acceptedFiles) => {
    const file = acceptedFiles[0];
    const reader = new FileReader();

    reader.onload = (event) => {
      console.log(event.target.result);
      setUrl(event.target.result);
    };
    reader.readAsDataURL(file);
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: ['image/jpg', 'image/jpeg', 'image/png'],
  });

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const addImage = () => {
    const { editorState, onChange } = props;
    if (url) {
      if (new Buffer(url, 'base64').length > 5000) {
        Notifier.error('Image to large!');
        return;
      }
      onChange(props.modifier(editorState, url));
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
    addImage();
    setUrl('');
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div>
      <Button
        size="small"
        aria-describedby={id}
        variant="contained"
        onClick={handleClick}>
        + Image
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}>
        <Typography className={classes.typography}>
          <TextField
            size="small"
            variant="outlined"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            placeholder="base64 or image url"
          />
          <Divider />
          <div {...getRootProps()}>
            <input placeholder="drop here" {...getInputProps()} />
            <div
              style={{
                height: '100px',
                width: 'auto',
                border: '1px dashed grey',
                borderRadius: '4px',
                background: isDragActive ? 'lightgreen' : 'white',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}>
              Upload Image
            </div>
          </div>{' '}
        </Typography>
      </Popover>
    </div>
  );
}
